import React, { useState, useEffect } from 'react';
import './info-tray.scss';

type InfoTrayProps = {
  title: string | React.ReactElement;
  selected: boolean;
  setSelected: React.Dispatch<React.SetStateAction<boolean | null>> | ((value?: unknown) => void);
  children: React.ReactNode;
  className?: string;
  headerContent?: React.ReactElement;
  hideCloseButton?: boolean;
  gapTop?: string;
  isFullscreen?: boolean;
};

export default function InfoTray({
  title,
  children,
  className,
  headerContent,
  selected = false,
  setSelected,
  hideCloseButton = false,
  gapTop,
  isFullscreen,
}: InfoTrayProps) {
  const [displayClass, setDisplayClass] = useState<string>('');
  const [isFirst, setIsFirst] = useState<boolean>(true);

  useEffect(() => {
    setDisplayClass(selected ? 'show' : isFirst ? '' : 'hide');
    if (selected && isFirst) {
      setIsFirst(false);
    }
  }, [selected, isFirst]);

  return (
    <div
      className={`InfoTray ${className || ''} ${displayClass} ${gapTop ? 'gap-top' : ''} ${
        isFullscreen ? 'full-screen' : ''
      }`}
      style={{ top: `${gapTop ? gapTop : '0'}` }}
    >
      <div className="info-tray-header">
        <div className="columns is-vcentered">
          <span className="column is-hidden-mobile">{title ? title : ''}</span>
          {!hideCloseButton && (
            <div className="column is-narrow">
              <span
                className="close-button is-icon-4 icon-cross-thin is-pulled-right"
                onClick={() => setSelected && setSelected(null)}
              ></span>
            </div>
          )}
        </div>
        <span
          className="is-hidden-tablet has-text-centered tray-title"
          style={{ display: 'block', width: '100%' }}
        >
          {title ? title : ''}
        </span>
        {headerContent}
      </div>
      <div className="info-tray-content">{children}</div>
    </div>
  );
}
